import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import ComboBox from './EditableComponents/ComboBox.js';
import TextBox from './EditableComponents/TextBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-basic/form/ComboBox';
import '@elliemae/ds-basic/form/TextBox';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var components = {
  DSComboBox: ComboBox,
  DSTextBox: TextBox
};

var getEditorComponent = function getEditorComponent() {
  var editorComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var handlers = arguments.length > 1 ? arguments[1] : undefined;
  return function (_ref) {
    var value = _ref.value,
        onValue = _ref.onValue,
        extraParameters = _ref.extraParameters;

    if (typeof editorComponent === 'function') {
      return editorComponent(_objectSpread({
        value: value,
        onValue: onValue,
        customHandlers: handlers
      }, extraParameters));
    }

    var _editorComponent$type = editorComponent.type,
        type = _editorComponent$type === void 0 ? 'DSTextBox' : _editorComponent$type,
        restEditorProps = _objectWithoutProperties(editorComponent, ["type"]);

    var Component = components[type];

    if (type === 'DSComboBox') {
      var _restEditorProps$opti;

      // TODO: remove this whole condition when combobox v3 is out and fully working without "maxOptions" parameter
      var maxOptions = (restEditorProps === null || restEditorProps === void 0 ? void 0 : (_restEditorProps$opti = restEditorProps.options) === null || _restEditorProps$opti === void 0 ? void 0 : _restEditorProps$opti.length) || 100;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          zIndex: 0
        }
      }, /*#__PURE__*/React.createElement(Component, _extends({
        autoFocus: true,
        onValue: onValue,
        value: value,
        maxOptions: maxOptions
      }, restEditorProps)));
    }

    return /*#__PURE__*/React.createElement(Component, _extends({
      autoFocus: true,
      onValue: onValue,
      value: value
    }, restEditorProps));
  };
};

export default getEditorComponent;
//# sourceMappingURL=getEditorComponent.js.map
